import React from 'react';
import './Roadmap.css';

const Roadmap: React.FC = () => {
  const roadmapData = [
    {
      year: 'Year 1',
      amount: '1 Billion',
      description: 'Initial market injection to establish USD.P liquidity and adoption',
      timeframe: '2024-2025',
      percentage: 20
    },
    {
      year: 'Year 2',
      amount: '1.5 Billion',
      description: 'Expanded distribution to support growing ecosystem demand',
      timeframe: '2025-2026',
      percentage: 50
    },
    {
      year: 'Year 3',
      amount: '2.5 Billion',
      description: 'Full-scale deployment to achieve global market penetration',
      timeframe: '2026-2027',
      percentage: 100
    }
  ];

  return (
    <section className="roadmap-section">
      <div className="container">
        <div className="roadmap-header">
          <h2 className="roadmap-title">USD.P Roadmap</h2>
          <p className="roadmap-subtitle">
            Strategic injection of 5 billion USD.P tokens over 3 years to ensure sustainable market growth
          </p>
        </div>

        <div className="roadmap-timeline">
          <div className="timeline-line"></div>
          
          {roadmapData.map((phase, index) => (
            <div key={index} className={`roadmap-phase ${index % 2 === 0 ? 'left' : 'right'}`}>
              <div className="phase-connector">
                <div className="phase-dot"></div>
              </div>
              
              <div className="phase-content">
                <div className="phase-header">
                  <h3 className="phase-year">{phase.year}</h3>
                  <span className="phase-timeframe">{phase.timeframe}</span>
                </div>
                
                <div className="phase-amount">
                  <span className="amount-value">{phase.amount}</span>
                  <span className="amount-label">USD.P Tokens</span>
                </div>
                
                <div className="phase-progress">
                  <div className="progress-bar">
                    <div
                      className="progress-fill"
                      style={{ width: `${phase.percentage}%` }}
                    ></div>
                  </div>
                  <span className="progress-percentage">{phase.percentage}% of Total Supply</span>
                </div>
                
                <p className="phase-description">{phase.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="roadmap-summary">
          <div className="summary-card">
            <h4>Total Supply Overview</h4>
            <div className="supply-breakdown">
              <div className="supply-item">
                <span className="supply-label">Total Minted</span>
                <span className="supply-value">5 Billion USD.P</span>
              </div>
              <div className="supply-item">
                <span className="supply-label">Injection Period</span>
                <span className="supply-value">3 Years</span>
              </div>
              <div className="supply-item">
                <span className="supply-label">Market Strategy</span>
                <span className="supply-value">Gradual Release</span>
              </div>
            </div>
          </div>
          
          <div className="summary-benefits">
            <h4>Release Strategy Benefits</h4>
            <ul>
              <li>Prevents market flooding and maintains price stability</li>
              <li>Allows ecosystem to grow organically with token supply</li>
              <li>Provides predictable liquidity for institutional adoption</li>
              <li>Ensures sustainable long-term growth trajectory</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Roadmap;